export const supportTicketUnreadForAgent = (input) => {
    const status = String(input.supportStatus || "OPEN").toUpperCase();
    if (status === "RESOLVED")
        return false;
    if (!input.baseUnread)
        return false;
    const viewer = String(input.viewerUserId || "")
        .trim()
        .toLowerCase();
    const requester = String(input.requesterUserId || "")
        .trim()
        .toLowerCase();
    const lastSender = String(input.lastMessageSenderUserId || "")
        .trim()
        .toLowerCase();
    const claimedBy = String(input.claimedBy || "")
        .trim()
        .toLowerCase();
    const waitingOnAgent = Boolean(requester && lastSender && lastSender === requester);
    if (!waitingOnAgent)
        return false;
    if (status === "CLAIMED" && claimedBy && claimedBy !== viewer)
        return false;
    return true;
};
